<div class="declinaison-columns">

  <div class="declinaison-col">

    <ng-content select="[informationsFields]"></ng-content>

    <div class="declinaison-panel">
      <span class="declinaison-panel-title"><strong>FACTURATION</strong></span>
      <div class="declinaison-panel-body">
        <div class="declinaison-row">
          <span>Compte comptable</span>
          <yo-lookup [data]="data().compteComptableList" [selectedItem]="data().compteComptableSelected?.id"
                     displayValue="libelleEtCode" [disabled]="data().isReadonly"
                     (onValueChange)="changeCompteComptable.emit($event)"></yo-lookup>
        </div>
        <div class="declinaison-row">
          <span>Prix de vente</span>
          <div class="declinaison-inline-value">
            <yo-number-box [value]="data().prixDeVente"
                           (onValueChanged)="changePrixDeVente.emit($event)"></yo-number-box>
            <span>{{data().prixSuffix}}</span>
          </div>
        </div>
        <div class="declinaison-row">
          <span>Taxe <span class="danger-color">*</span></span>
          <yo-lookup [data]="data().taxeList" [selectedItem]="data().taxeSelected?.id" [disabled]="data().isReadonly"
                     (onValueChange)="changeTaxe.emit($event)"></yo-lookup>
        </div>
        <div class="declinaison-row">
          <span>Famille de facturation</span>
          <yo-lookup [data]="data().famillesFacturation" [selectedItem]="data().familleFacturationSelected?.id"
                     [disabled]="data().isReadonly" (onValueChange)="changeFamilleFacturation.emit($event)"></yo-lookup>
        </div>
      </div>
    </div>
  </div>

  <div class="declinaison-col">

    <div class="declinaison-panel">
      <span class="declinaison-panel-title"><strong>FABRICATION</strong></span>
      <div class="declinaison-panel-body">
        <div class="declinaison-row">
          <span>Unité technique <span class="danger-color">*</span></span>
          <yo-lookup [data]="data().uniteDeMesureList" [selectedItem]="data().uniteDeMesureSelected?.id"
                     [disabled]="data().isReadonly || data().isLockedAfterCreation"
                     (onValueChange)="changeUniteDeMesure.emit($event)"></yo-lookup>
        </div>
        @if (data().uniteDeMesureWarning) {
          <div class="declinaison-row">
            <span></span>
            <span class="danger-color">{{data().uniteDeMesureWarning}}</span>
          </div>
        }
        <div class="declinaison-row">
          <span>{{data().ratioUniteTechniqueLabel}} <span class="danger-color">*</span></span>
          <div class="declinaison-inline-value">
            <span>{{data().ratioUniteTechniquePrefix}}</span>
            <yo-number-box [value]="data().ratioUniteTechnique"
                           (onValueChanged)="changeRatioUniteTechnique.emit($event)"></yo-number-box>
            <span>KG</span>
          </div>
        </div>
        <div class="declinaison-row">
          <span>{{data().inverseRatioTechniqueLabel}} <span class="danger-color">*</span></span>
          <div class="declinaison-inline-value">
            <span>{{data().inverseRatioTechniquePrefix}}</span>
            <yo-number-box [value]="data().inverseRatioTechnique"
                           (onValueChanged)="changeInverseRatioUniteTechnique.emit($event)"></yo-number-box>
            <span>{{data().uniteDeMesureSelected?.libelle?.toUpperCase()}}</span>
          </div>
        </div>
        @if (data().ratioVolumeRequired) {
          <div class="declinaison-row">
            <span>Ratio Volume <span class="danger-color">*</span></span>
            <div class="declinaison-inline-value">
              <span>1 LITRE équivaut à</span>
              <yo-number-box [value]="data().ratioVolume"
                             (onValueChanged)="changeRatioVolume.emit($event)"></yo-number-box>
              <span>KG</span>
            </div>
          </div>
        }
        <div class="declinaison-row">
          <span>Date limite de conso. <span class="danger-color">*</span></span>
          <div class="declinaison-inline-value">
            <yo-number-box [value]="data().dlc"
                           (onValueChanged)="changeDlc.emit($event)"></yo-number-box>
            <span>jour(s)</span>
          </div>
        </div>
        <div class="declinaison-row">
          <span>Régimes <span class="danger-color">*</span></span>
          <yo-multiselect [data]="data().contraintesAlimList" [selectedItems]="data().regimesSelectedIds"
                           displayValue="libelle" key="id" placeholder="Régimes..." [disabled]="data().isReadonly"
                           (onValueChange)="changeRegimes.emit($event)"></yo-multiselect>
        </div>
        <div class="declinaison-row">
          <span>Type de fabrication <span class="danger-color">*</span></span>
          <yo-lookup [data]="data().tacheFabricationList" [selectedItem]="data().tacheFabricationSelected?.id"
                     [disabled]="data().isReadonly" (onValueChange)="changeTacheFabrication.emit($event)"></yo-lookup>
        </div>
      </div>
    </div>
  </div>
</div>
